import { render } from "./wAccountsTree.vue?vue&type=template&id=5589e871&ts=true"
import script from "./wAccountsTree.vue?vue&type=script&lang=ts"
export * from "./wAccountsTree.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__